export default __webpack_public_path__ + "static/media/img_about1.1232d112.png";